export default function normalize<T extends object>(collection: T[], idProperty: keyof T) {
  const normal = collection.reduce<Record<string, T>>((normalized, current) => {
    const id = current[idProperty];
    if (typeof id === 'string') {
      normalized[id] = { ...current };
    }

    return normalized;
  }, {});

  return normal;
}
